import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { StorageService } from '../services/storage/storage.service';

/**
 * A guard that checks if the user is an admin.
 * @returns True if the user is an admin, false otherwise.
 */
@Injectable({
  providedIn: 'root'
})
export class AdminGuard  {

  constructor(private _storage: StorageService) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {
    return this._storage.isAdmin()
  }
}
